import { render, staticRenderFns } from "./send-devices.vue?vue&type=template&id=cf991246&scoped=true&"
import script from "./send-devices.vue?vue&type=script&lang=js&"
export * from "./send-devices.vue?vue&type=script&lang=js&"
import style0 from "./send-devices.vue?vue&type=style&index=0&id=cf991246&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf991246",
  null
  
)

export default component.exports